"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickFilterSchema = void 0;
var zod_1 = require("zod");
var QuickFilterItemSchema = zod_1.z.object({
    // 필터 code값 (code filter일 때)
    code: zod_1.z.string().optional(),
    // 필터 key값
    key: zod_1.z.string(),
    // 필터 선택 여부
    selected: zod_1.z.boolean(),
    // 노출할 퀵필터 타이틀
    title: zod_1.z.string(),
    // 퀵필터 타입
    type: zod_1.z.enum(['OPEN_GLOBAL_FILTER', 'REQUEST']),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.QuickFilterSchema = zod_1.z.object({
    items: zod_1.z.array(QuickFilterItemSchema),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
